export const LOCATIONS_CODES = {
    UK: {
        code: 'UK',
        name: 'UK'
    },
    NY1: {
        code: 'NY1',
        name: 'New York State (1)'
    },
    NY2: {
        code: 'NY2',
        name: 'New York State (2)'
    },
    CA: {
        code: 'CA',
        name: 'California State'
    },
    WI: {
        code: 'WI',
        name: 'Wisconsin'
    },
    WY: {
        code: 'WY',
        name: 'Wyoming'
    },
    WV: {
        code: 'WV',
        name: 'West Virginia'
    },
    VA: {
        code: 'VA',
        name: 'Virginia'
    },
    VT: {
        code: 'VT',
        name: 'Vermont'
    },
    UT: {
        code: 'UT',
        name: 'Utah'
    },
    TX: {
        code: 'TX',
        name: 'Texas'
    },
    TN: {
        code: 'TN',
        name: 'Tennessee'
    },
    SD: {
        code: 'SD',
        name: 'South Dakota'
    },
    SC: {
        code: 'SC',
        name: 'South Carolina'
    },
    RI: {
        code: 'RI',
        name: 'Rhode Island'
    },
    PA: {
        code: 'PA',
        name: 'Pennsylvania'
    },
    OR: {
        code: 'OR',
        name: 'Oregon'
    },
    OK: {
        code: 'OK',
        name: 'Oklahoma'
    },
    OH: {
        code: 'OH',
        name: 'Ohio'
    },
    ND: {
        code: 'ND',
        name: 'North Dakota'
    },
    NC: {
        code: 'NC',
        name: 'North Carolina'
    },
    NM: {
        code: 'NM',
        name: 'New Mexico'
    },
    NJ: {
        code: 'NJ',
        name: 'New Jersey',
    },
    NH: {
        code: 'NH',
        name: 'New Hampshire',
    },
    NV: {
        code: 'NV',
        name: 'Nevada',
    },
    NE: {
        code: 'NE',
        name: 'Nebraska'
    },
    MT: {
        code: 'MT',
        name: 'Montana'
    },
    MO: {
        code: 'MO',
        name: 'Missouri'
    },
    MS: {
        code: 'MS',
        name: 'Mississippi'
    },
    MN: {
        code: 'MN',
        name: 'Minnesota'
    },
    MI: {
        code: 'MI',
        name: 'Michigan'
    },
    MA: {
        code: 'MA',
        name: 'Massachusetts'
    },
    MD: {
        code: 'MD',
        name: 'Maryland'
    },
    ME: {
        code: 'ME',
        name: 'Maine'
    },
    LA: {
        code: 'LA',
        name: 'Louisiana'
    },
    KS: {
        code: 'KS',
        name: 'Kansas'
    },
    IA: {
        code: 'IA',
        name: 'Iowa'
    },
    IN: {
        code: 'IN',
        name: 'Indiana'
    },
    ID: {
        code: 'ID',
        name: 'Idaho'
    },
    HI: {
        code: 'HI',
        name: 'Hawaii'
    },
    GA: {
        code: 'GA',
        name: 'Georgia'
    },
    FL: {
        code: 'FL',
        name: 'Florida'
    },
    DC: {
        code: 'DC',
        name: 'District of Columbia'
    },
    DE: {
        code: 'DE',
        name: 'Delaware'
    },
    AR: {
        code: 'AR',
        name: 'Arkansas'
    },
    AZ: {
        code: 'AZ',
        name: 'Arizona'
    },
    AK: {
        code: 'AK',
        name: 'Alaska'
    },
    AL: {
        code: 'AL',
        name: 'Alabama'
    },
    IL: {
        code: 'IL',
        name: 'Illinois'
    },
    KY: {
        code: 'KY',
        name: 'Kentucky'
    },
    CO: {
        code: 'CO',
        name: 'Colorado'
    },
    CT: {
        code: 'CT',
        name: 'Connecticut'
    },
    WA: {
        code: 'WA',
        name: 'Washington'
    }
};

export const BREAK_RULES_PAYMENT_TYPE = {
    UNPAID: 'UNPAID',
    PAID: 'PAID'
};

export const BREAK_RULES_CATEGORY = {
    MEAL: 'MEAL',
    ORDINARY: 'ORDINARY'
};

export const BREAK_RULES_STATUS = {
    SHORT: 'SHORT',
    LATE: 'LATE'
}

export const BREAK_STATUSES = {
    SHORT_REST: 'SHORT_REST',
    SHORT_MEAL: 'SHORT_MEAL',
    LATE_MEAL: 'LATE_MEAL',
}

export const BREAK_RULES_REPETITION_TIMES = {
    ONCE: 'ONCE',
    FOREVER: 'FOREVER'
};

window.ATTESTATION_BREAK_STATUSES = [
    {status: BREAK_RULES_STATUS.SHORT, category: BREAK_RULES_CATEGORY.ORDINARY, label: $filter("translate")("Short rest break"), code: BREAK_STATUSES.SHORT_REST},
    {status: BREAK_RULES_STATUS.SHORT, category: BREAK_RULES_CATEGORY.MEAL, label: $filter("translate")("Short meal break"), code: BREAK_STATUSES.SHORT_MEAL},
    {status: BREAK_RULES_STATUS.LATE, category: BREAK_RULES_CATEGORY.MEAL, label: $filter("translate")("Late meal break"), code: BREAK_STATUSES.LATE_MEAL}
]

export const BREAK_RULES_AGE_CLASSIFICATION = {
    ALL: 'ALL',
    ADULT: 'ADULT',
    MINOR: 'MINOR'
};

export const BREAK_MODES = {
    STATIC: 'STATIC',
    DYNAMIC: 'DYNAMIC'
}

export const BREAK_RULES_PAYMENT_MODE = {
    NO_PAYMENT: 'NO_PAYMENT'
};

export const BREAK_SHIFT_RULES = {
    START_BETWEEN: 'START_BETWEEN',
    END_BETWEEN: 'END_BETWEEN'
};

export const BREAK_RULE_PREFERRED_TIME = {
    MIDWAY: 'MIDWAY',
    BETWEEN_TIME: 'BETWEEN_TIME',
    MID_ELIGIBILITY_PERIOD: 'MID_ELIGIBILITY_PERIOD'
};

export const BREAK_RULE_TYPE = {
    NOT_BEFORE: 'NOT_BEFORE',
    NOT_AFTER: 'NOT_AFTER',
    BETWEEN: 'BETWEEN',
};

export const REFERENCE_POINT = {
    SHIFT_START: 'SHIFT_START',
    SHIFT_END: 'SHIFT_END'
};

export const MISSED_BREAK_ACTION_MODES = {
    NO_ACTION: 'NO_ACTION',
    WAIVE: 'WAIVE',
    WAIVE_MISSED: 'WAIVE_MISSED',
    WAIVE_MISSED_UNPAID: 'WAIVE_MISSED_UNPAID'
}

export const BREAK_PREMIUM_CODES = {
    CA: 'CA',
    WA: 'WA',
    NONE: 'NONE'
}

export const BREAK_PREMIUM_TYPES = [
    {code: BREAK_PREMIUM_CODES.CA, label: $filter("translate")("California")},
    {code: BREAK_PREMIUM_CODES.WA, label: $filter("translate")("Washington")},
];

export const PREMIUM_BREAK_STATUSES = {
    MISSED_BREAK: 'MISSED_BREAK',
    LATE_MEAL_BREAK: 'LATE_MEAL_BREAK',
    SHORT_BREAK: 'SHORT_BREAK',
}

export const CONFIRMATION_FOR_BREAK_PREMIUMS_TYPES = [
    {code: PREMIUM_BREAK_STATUSES.MISSED_BREAK, label: $filter("translate")("Missed break premium")},
    {code: PREMIUM_BREAK_STATUSES.SHORT_BREAK, label: $filter("translate")("Short break premium")},
    {code: PREMIUM_BREAK_STATUSES.LATE_MEAL_BREAK, label: $filter("translate")("Late meal break premium")},
];